import css from './PostNavigation.module.scss';
import H6title from '../titles/H6title';
import classNames from 'classnames';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faArrowRight, faArrowLeft} from '@fortawesome/free-solid-svg-icons'
import {useBlogContext} from '../BlogContext';
import {useEffect, useState} from 'react';
import i18n from 'i18next';
import {useTranslation} from 'react-i18next';

export default function PostNavigation({id}) {
  const {t} = useTranslation();
  const [prev, setPrev] = useState(null);
  const [next, setNext] = useState(null);
  const {blogList} = useBlogContext();
  const {posts} = blogList;
  const index = posts.findIndex(postId => postId === id);
  const lang = i18n.language === 'en' ? 'en' : 'ru';

  useEffect(() => {
    setPrev(null);
    setNext(null);

    if (index < posts.length - 1) {
      fetch(`/blog/${posts[index + 1]}/${lang}/metadata.json`)
        .then(res => res.json())
        .then(text => {
          setNext(text)
        });
    }
    if (index > 0) {
      fetch(`/blog/${posts[index - 1]}/${lang}/metadata.json`)
        .then(res => res.json())
        .then(text => {
          setPrev(text)
        });
    }
  }, [index, id, lang, posts]);

  return (
    <>
      <div className={css.blogTemplatePagination}>
        <div className={css.blogTemplatePrevButton}>
          {
            prev && (
              <a href={`/#/blog/${posts[index - 1]}`}
                 className={classNames(css.a, css.blogTemplatePaginationLink)}>
                <span className={css.prevPostArrow}><FontAwesomeIcon icon={faArrowLeft}/></span>
                <div>
                  <p className={css.prevPost}>
                    {t('blog.next-post')}
                  </p>
                  <H6title cn={css.colorInherit}>{prev['title']}</H6title>
                </div>
              </a>
            )
          }
        </div>
        <div className={css.blogTemplateNextButton}>
          {
            next && (
              <a href={`/#/blog/${posts[index + 1]}`}
                 className={classNames(css.a, css.blogTemplatePaginationLink)}>
                <div className={css.blogTemplateNext}>
                  <p className={css.nextPost}>
                    {t('blog.previous-post')}
                  </p>
                  <H6title
                    cn={classNames(css.colorInherit, css.blogDetailsLinkTitle, css.right)}>{next['title']}</H6title>
                </div>
                <span className={css.nextPostArrow}><FontAwesomeIcon icon={faArrowRight}/></span>
              </a>
            )
          }
        </div>
      </div>
    </>
  );
}